import { __decorate } from "tslib";
import { registerDecorator, ValidatorConstraint, } from 'class-validator';
import { Money } from '../Money';
export function IsPositiveMoney(property, validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [property],
            validator: MoneyPositiveConstraint,
        });
    };
}
/**
 * Validates whether a Money amount is greater than zero.
 * @see https://github.com/typestack/class-validator#custom-validation-classes
 */
let MoneyPositiveConstraint = class MoneyPositiveConstraint {
    validate(money) {
        if (money instanceof Money) {
            return money.amount.isGreaterThan(0);
        }
        else {
            return false;
        }
    }
    defaultMessage() {
        return '$value amount is not greater than 0';
    }
};
MoneyPositiveConstraint = __decorate([
    ValidatorConstraint({ name: 'moneyPositive', async: false })
], MoneyPositiveConstraint);
export { MoneyPositiveConstraint };
